import DownloadBtn from './DownloadBtn.vue';

export default DownloadBtn;
